import React from 'react';
import { Table } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import {
	QUES_CODE_PREFIX,
	formatBrsrNumericCellValue,
	getFormattedTextEmbeddedinLITag,
	renderQuestionAnswer,
	renderType1TableAnswerForCurrentYear,
	renderType3TableAnswerForCurrentYear
} from '../../../../core/utilities/BRSRUtils';
import './../Reporting.scss';

const BRSRPrinciple7 = ({
	t,
	page9,
	yearFilter
}) => {
	const page9Data = page9?.currentYear ?? page9;
	/** Shape expected by renderType1/3TableAnswerForCurrentYear: { currentYear: { 'BRSR-…': block } } */
	const yearTablePageData =
		page9?.currentYear != null ? page9 : { currentYear: page9 || {} };

	const renderTableAnswerForCurrentYearWrapper = (qIndex, colNos) => {
		const block = yearTablePageData.currentYear?.[QUES_CODE_PREFIX + qIndex];
		if (block?.keyValueType === 'TYPE_3_TABLE') {
			const type3 = renderType3TableAnswerForCurrentYear(yearTablePageData, 9, qIndex, colNos);
			if (type3 != null) return type3;
		}
		return renderType1TableAnswerForCurrentYear(yearTablePageData, 9, qIndex, colNos);
	};

	const renderP7Q1 = () => {
		const answer = {};
		if (page9Data) {
			page9Data[QUES_CODE_PREFIX + 'P7-1']?.keyValues?.forEach(val => {
				answer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>1.</b>
				{renderQuestionAnswer('a. Number of affiliations with trade and industry chambers/ associations.', answer[QUES_CODE_PREFIX + 'P7-1a'] ?? '')}
				<div className="table_list01">
					<b>b. List the top 10 trade and industry chambers/ associations (determined based on the  total members of such body) the entity is a member of/ affiliated to.</b>
				</div>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th className='white-space'>S. No.</th>
								<th>Name of the trade and industry chambers/ associations</th>
								<th>Reach of trade and industry chambers/ associations (State/National)</th>
							</tr>
						</thead>
						<tbody>
							{renderTableAnswerForCurrentYearWrapper('P7-1b', ['', '1a', '1b'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP7Q2 = () => {
		return (
			<div className='brsr-list-item'>
				<b>2. Provide details of corrective action taken or underway on any issues related to anti-competitive conduct by the entity, based on adverse orders from regulatory authorities</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th>Name of authority</th>
								<th>Brief of the case</th>
								<th>Corrective action taken</th>
							</tr>
						</thead>
						<tbody>
							{renderTableAnswerForCurrentYearWrapper('P7-2', ['a', 'b', 'c'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP7LIQ1 = () => {
		return (
			<div className='brsr-list-item'>
				<b>1. Details of public policy positions advocated by the entity.</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th className='white-space'>S. No.</th>
								<th>Public policy advocated</th>
								<th>Method resorted for such advocacy</th>
								<th>Whether information available in public domain? (Yes/No)</th>
								<th>Frequency of Review by Board (Annually / half yearly / Quarterly / Others - please specify)</th>
								<th>Web Link, if available</th>
							</tr>
						</thead>
						<tbody>
							{renderTableAnswerForCurrentYearWrapper('P7-LI1', ['', 'a', 'b', 'c', 'd', 'e'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	return (
		<section id="PRINCIPLE_7" className="Main_Section PRINCIPLE_7">
			<div className="ETA_card_Section 1" >
				<div className="ETA_card_Section_head" >
					<h5>PRINCIPLE 7 Businesses, when engaging in influencing public and regulatory policy, should do so in a manner that is responsible and transparent</h5>
				</div>
				<div className="ETA_card_Section_sub" >
					<section className="mb-4">
						<div className="ETA_card_Section_sub_head" >
							<b>Essential Indicators</b>
						</div>
						<div className="ETA_card_Section_sub_body" >
							<div className='brsr-list'>
								{renderP7Q1()}
								{renderP7Q2()}
							</div>
						</div>
					</section>
				</div>
				<div className="ETA_card_Section_sub mt-2">
					<section className="mb-4">
						<div className="ETA_card_Section_sub_head" >
							<b>Leadership Indicators</b>
						</div>
						<div className="ETA_card_Section_sub_body" >
							<div className='brsr-list'>
								{renderP7LIQ1()}
							</div>
						</div>
					</section>
				</div>
			</div>
		</section>
	);
};

export default withTranslation()(BRSRPrinciple7);
